import React, {Component} from "react";
import styles from './FJVideo.module.less';

class FJVideo extends Component{

	render() {

		let {
			url,
			videoRef,
			onLoadedData,
			onEnded,
			onError
		} = this.props;

		return (
			<video className={styles.video_container}
						 src={url}
						 ref={videoRef}
						 onLoadedData={onLoadedData}
						 onEnded={onEnded}
						 onError={onError}
			/>
		)
	}

}


export default FJVideo;